const base = '/';
let apiBase             = "https://api.reins-global.com/api/";
if (process.env.NODE_ENV === "production") {
    apiBase             = "https://api.reins-global.com/api/";
}

export const paths = {
    home: base,
    admin:{
        home: base + 'admin',
        joinMe: base + 'admin/join-me-list',
        insightList: base + 'admin/insight-list',
        career: base + 'admin/career',
    },
// API's
    api: {
        // Admin API's
        admin:{
            joinMeList          : apiBase + 'web_admin/join-me/register-list',
            login               : apiBase + 'web_admin/admin-login',
            getExcelJoin        : apiBase + 'web_admin/join-me/register-list-xlx',
            insightUpload       : apiBase + 'web_admin/upload/insights-document',
            insightList         : apiBase + 'web_admin/upload/insights-document-list',
            insightStatusUpdate : apiBase + 'web_admin/upload/insights-document-active',
            createCareer        : apiBase + 'web_admin/career',
            updateCareer        : apiBase + 'web_admin/career',
            getAllCareer        : apiBase + 'web_admin/career',
            updateCareerStatus  : apiBase + 'web_admin/career/activation',
        },
    }
}